import { render } from "./PurchaseOrderList.vue?vue&type=template&id=37c6490c"
import script from "./PurchaseOrderList.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__